import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// reactstrap components
import {
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  NavbarBrand,
  Container,
  Row,
  Col,
} from "reactstrap";

function AuthNavbar() {
  const [navOpen, setNavOpen] = React.useState(false);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };
  return (
    <>
      <Navbar
        className="navbar-horizontal navbar-main navbar-dark navbar-transparent"
        expand="lg"
        id="navbar-main"
      >
        <Container>
          <NavbarBrand to="/" tag={Link}>
            <img
              alt="..."
              src={require("assets/img/brand/biteLogrLogos/LogoOnly.png")}
            />
          </NavbarBrand>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => toggleNav()}
          >
            <span className="navbar-toggler-icon" />
          </button>
          <Collapse isOpen={navOpen} className="navbar-custom-collapse" navbar>
            <div className="navbar-collapse-header">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <Link to="/auth/home">
                    <img
                      alt="..."
                      src={require("assets/img/brand/biteLogrLogos/LogoHorizontal.png")}
                    />
                  </Link>
                </Col>
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => toggleNav()}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav className="mr-auto" navbar>
              <NavItem>
                <NavLink to="/auth/home" tag={Link} onClick={() => toggleNav()}>
                  <span className="nav-link-inner--text">Home</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/auth/register"
                  tag={Link}
                  onClick={() => toggleNav()}
                >
                  <span className="nav-link-inner--text">Register</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/auth/login"
                  tag={Link}
                  onClick={() => toggleNav()}
                >
                  <span className="nav-link-inner--text">Login</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/auth/pricing"
                  tag={Link}
                  onClick={() => toggleNav()}
                >
                  <span className="nav-link-inner--text">Pricing</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/auth/faq" tag={Link} onClick={() => toggleNav()}>
                  <span className="nav-link-inner--text">FAQ</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/auth/about"
                  tag={Link}
                  onClick={() => toggleNav()}
                >
                  <span className="nav-link-inner--text">About</span>
                </NavLink>
              </NavItem>
            </Nav>
            <hr className="d-lg-none" />
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AuthNavbar;
